module.exports = "//public.zight.com/packs/media/images/app-icon-ee9e56acfc047a00f9035fe12eb92993.svg";